// extracted by mini-css-extract-plugin
export default {"recos":"_3-z","productCardOverride":"a4-z","rowHasBadge":"b4-z"};